module.exports = __webpack_public_path__ + "static/media/archeology.34c9ac78.svg";